import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TSizeMapItem } from '@monorepo/types';

@Component({
  selector: 'monorepo-size-filter',
  templateUrl: './size-filter.component.html',
  styleUrls: ['./size-filter.component.scss'],
})
export class SizeFilterComponent implements OnInit {
  @Input() sizeList: TSizeMapItem[] = [];
  @Input() filteredList: boolean[] = [];

  isAllSelected: boolean = false;
  isAnySizeSelected: boolean = false;
  constructor(private modalController: ModalController) {}

  ngOnInit(): void {
    this.isAllSelected = this.filteredList.every((v) => v);
    this.updateIsAnySizeSelected();
  }

  handleCancel() {
    this.modalController.dismiss();
  }

  selectAll($event: any) {
    this.isAllSelected = $event.detail.checked;
    const unSelectAll = this.filteredList.every((v) => v === true);
    this.filteredList = this.filteredList.map((item) => (this.isAllSelected ? true : unSelectAll ? false : item));
    this.updateIsAnySizeSelected();
  }

  handleOnChange($event: any, index: number) {
    console.log('CHECKBOX', $event);
    console.log('[Visible list]', this.filteredList);
    this.filteredList[index] = $event.detail.checked;
    this.isAllSelected = this.filteredList.every((v) => v === true);
    this.updateIsAnySizeSelected();
  }

  updateIsAnySizeSelected() {
    this.isAnySizeSelected = !this.filteredList.every((v) => !v);
  }

  handleSave() {
    if (!this.isAnySizeSelected) return;
    this.modalController.dismiss(this.filteredList);
  }
}
